import React from "react";
import { css, Global } from "@emotion/core";
import { useTheme } from "emotion-theming";


export const NewFormStyle = ({ isNewAddressDesignEnabled }: any) => {
    const theme = useTheme();
    return (
      <Global theme={theme}
        styles={css` 

        .input-wrapper {
            &.expand-input {
                margin-bottom: 20px;
            }
            &.split-input {
                flex-grow: 1;
            }
            ${isNewAddressDesignEnabled && `
                .alert-message-layout {
                    padding: ${theme.alertPadding};
                    margin: ${theme.newAddressInputErrorMargin};
                }
            `}

            .input-element {
                background: linear-gradient(0deg, rgba(101, 119, 134, 0.08), rgba(101, 119, 134, 0.08)), #FFFFFF;
                border-radius: 8px;
            }
        }

        .form-field {
            position: relative;
            margin-bottom: ${isNewAddressDesignEnabled ? "16px" : "8px"};
            flex: 1;
            > .form-field {
                padding-top:0;
            }
            &.single-field {
                margin-top: 0;
            }

            &.single {
                display: inline-block;
                import FormStyle from 'assets/scss/common/form';
                width: 88%;
            }

            .error-section {
                display: none;
            }

            &.error {
                .input-element {
                    background-color: rgba(182, 0, 0, 0.08);
                    border-bottom-color: ${theme.red};
                    padding-right: 25px;

                    &:focus {
                        border-color: ${theme.red};
                    }
                }

            .error-section {
                display: block;
            }
            .error-icon {
                position: absolute;
                right: 5px;
                bottom: 2px;
            }

            .field-error {
                color: ${theme.red};
                display: block;
                font-size: 10px;
                font-weight: 600;
                text-transform: uppercase;
                position: absolute;
                bottom: -20px;
                right: 5px;
            }
        }

        .floating-label {
            color: ${theme.grey.G5};
            pointer-events: none;
            margin-bottom: 5px;
        }

        &.other {
            margin-bottom: 20px;
            padding-top: 0;

            .input-element {
                padding-bottom: 2px;
                padding-top: 2px;
            }
        }

        .down-icon {
            position: absolute;
            right: 10px;
            bottom: 3px;
        }
    }

    .input-element {
        background: transparent;
        border: 0;
        border-radius: 8px;
        border-bottom: 1px solid ${theme.grey.G2};
        color: ${theme.primaryText};
        font-weight: 400;
        line-height: 20px;
        outline: 0;
        padding: 20px 0 8px 16px;
        transition: border-color .2s;
        width: 100%;

        &::placeholder {
            ${isNewAddressDesignEnabled ? "opacity: 0;" : "color: transparent;"}
        }

        &:placeholder-shown {

            & ~ .floating-label {
            cursor: text;
            font-size: 14px;
            font-weight: 400;
            top: 14px;
            left: 16px;
            }
        }

        &:focus {
            border-bottom: 2px solid ${theme.brandPrimary};

            & ~ .floating-label {
                color: ${theme.brandPrimary};
                text-transform: capitalize;
            }
        }

        &:-webkit-autofill {
            transition: background-color 1000s ease-in-out 0s;
            -webkit-box-shadow: 0 0 0 30px #f3f4f5 inset;
        }
    }


    label.floating-label,
    .input-element:focus ~ .floating-label {
        color: ${theme.grey.G5};
        display: block;
        font-size: 12px;
        font-weight: 400;
        position: absolute;
        top: 4px;
        left: 16px;
        text-transform: capitalize;
        transition: .2s;

        
        ${isNewAddressDesignEnabled && `
            .input-element:focus::placeholder {
                opacity: 1;
            }   
        `}

        &.lower-text {
            text-transform: lowercase;
        }
    }

    .input-element.input-area {
        margin-bottom: -5px;
    }
`}
        />
    );
};

export default NewFormStyle;
